import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { observer } from "mobx-react-lite";
import useStore from "stores";
import { Tabs } from "antd";
// import { useDetailApi } from "components/vop_document/App/hooks";
import VopHeader from "components/vop_header";
import VopFooter from "components/vop_footer";
import HomeHeader from "components/HomeHeader";
import FeedBack from "components/vop_feedback";
import SurveyInfo from "components/vop_surveyInfo";
import { loginUrl } from "utils/api/ajax";
import { queryComponentDetailByIndexName, getGuideArticleDetail, queryComponentHelpAndSupport } from "utils/api/index";
import Utils from 'utils/utils.js';
import Solution from "./solution";
import ButtJoint from "./buttJoint";
import "./style.scss";

const ComponentDetails = observer(() => {
  
  const [empty, setEmpty] = useState(null);
  const { loginStore } = useStore();
  const [headerData, setHeaderData] = useState({
    bgColor: "linear-gradient(180deg, rgba(7,7,7,1) 0%,rgba(3,3,3,0) 100%)",
  });
  const [activeNav, setActiveNav] = useState("tab-1");
  const { TabPane } = Tabs;
  const [navData, setNavData] = useState([
    {
      title: "解决方案",
      id: "tab-1",
    },
    {
      title: "产品对接方案",
      id: "tab-2",
    },
  ]);
  const [bannerImg, setBannerImg] = useState(""); // banner
  const [solutionArticle, setSolutionArticle] = useState(""); // 解决方案
  const [componentArticle, setComponentArticle] = useState(""); // 产品对接方案
  const [helpAndSupport, setHelpAndSupport] = useState(""); // 解决方案
  const [componentName, setComponentName] = useState(""); // 组件的componentName
  const [componentContent, setComponentContent] = useState("");


  useEffect(() => {
    document.title = "京东VOP开放平台-门户";
    window.scrollTo(0, 0);
    window.onscroll = () => {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 50) {
        setHeaderData({
          bgColor: "#000",
        });
      } else {
        setHeaderData({
          bgColor:
            "linear-gradient(180deg, rgba(7,7,7,1) 0%,rgba(3,3,3,0) 100%)",
        });
      }
    };
    
  }, []);

  useEffect(()=>{
    if (empty == null) {
      let name = Utils.getQueryVariable('componentIndexName')
      // console.log('name', name)
      setComponentName(name)
      queryComponentDetailByIndexName({componentIndexName: name}).then(async(res) => {
        // console.log('res', res)
        const {result, success} = res.data;
        if( success ) {
          // console.log('result', result)
          setBannerImg(result.componentDetailIcon)
          setComponentContent(result.componentContent)
          let solutionId = result.solutionArticle
          let componentId = result.componentArticle
          await articleContent({
            articleId: solutionId
          }, 'solution');
          await articleContent({
            articleId: componentId
          }, 'component', name);
          setEmpty(!res.data.result);
          // console.log('listData', listData)
        }
      });
      
    }
  },[empty])

  const articleContent = (param, type, name) => {
    getGuideArticleDetail(param)
    .then(function (response) {
      if (response.status === 200) {
        const result = response.data;
        // console.log('result',result)
        if (result.success) {
          const data = result.result;
          // console.log('data',data)
          if(type == 'solution') {
            setSolutionArticle(data);
          } else {
            setComponentArticle(data);
            queryComponentHelpAndSupport({componentIndexName: name}).then(async(res) => {
              const {result, success} = res.data;
              if( success ) {
                // console.log('Support result', result)
                setHelpAndSupport(result)
              }
            })
            
          }
        }
      }
    })
    .catch(function (error) {
      console.log(error);
    });
  }

  const handleClick = (activeItem, index) => {
    setActiveNav(activeItem.id);
  };

  return (
    <div className=" component_details">
      <div className="component-box">
        <VopHeader {...headerData} contentWidth="1200px">
          <HomeHeader />
        </VopHeader>
      </div>
      <div className="component-box component-banner">
        <img src={bannerImg} />
        <div className="content">
          <div className="back"
            onClick={()=> {
              window.history.back(-1);
            }}
          >
            <i className="icon-back"></i>返回列表
          </div>
          <h3 className="title">{componentName}</h3>
          <h3 className="desc">{componentContent}</h3>
          <Link
            className="btn"
            to={loginStore.isLogin ? "/app/frame" : loginUrl}
            clstag="pageclick|keycount|VopOpenIndex_1602911919488|39" 
          >
            前去订阅
          </Link>
        </div>
      </div>
      <div className={`component-box component-nav`}>
        <Tabs
          defaultActiveKey="1"
          centered
          // activeKey={activeNav}
          onChange={(key) => handleClick(key)}
          animated={false}
        >
          <TabPane tab={"解决方案"} key="1">
            <Solution detail={solutionArticle} /> 
          </TabPane>
          <TabPane tab={"产品对接方案"} key="2">
            <ButtJoint detail={componentArticle} support={helpAndSupport} />
          </TabPane>
        </Tabs>
      </div>
      <div className="jdw-container">
        <div className="jdw-row">
          <div className="jdw-column">
            <div
              className="jdw-widget"
              data-name="vop_footer"
              data-version="2.0.0">
              <VopFooter />
            </div>
          </div>
        </div>
      </div>

      <FeedBack></FeedBack>
      <SurveyInfo></SurveyInfo>
    </div>
  );
});

export default ComponentDetails;
